import React from 'react';
import { useTranslation } from 'react-i18next';
import { SpinnerColorScheme } from '@amzn/atoz-web/Spinner';
import { LoadingButton } from '../../shared';
export var AddOpportunityModalButton = function (_a) {
    var onClick = _a.onClick, loading = _a.loading;
    var t = useTranslation().t;
    return (React.createElement(LoadingButton, { loading: loading, onClick: onClick, spinnerColor: SpinnerColorScheme.Inverted, dataTestId: "AddOpportunityModalButton", ariaLabel: t('shift_management_features_AddOpportunityModalButton_buttonLabel'), buttonText: t('shift_management_features_AddOpportunityModalButton_buttonText') }));
};
